var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 175.16,
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 161.68
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#41479B"
    },
    width: 512,
    height: 87.58
  }), /*#__PURE__*/React.createElement("rect", {
    y: 87.58,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 87.58
  }), /*#__PURE__*/React.createElement("rect", {
    y: 424.42,
    style: {
      fill: "#41479B"
    },
    width: 512,
    height: 87.58
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 336.84,
    style: {
      fill: "#F5F5F5"
    },
    width: 512,
    height: 87.58
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#F5F5F5"
    },
    cx: 117.02,
    cy: 256,
    rx: 63.02,
    ry: 67.37
  })), /*#__PURE__*/React.createElement("rect", {
    x: 84.42,
    y: 229.92,
    style: {
      fill: "#3CC8FF"
    },
    width: 65.19,
    height: 32.598
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "93.117,248.458 93.861,255.65 96.791,249.04 95.276,256.109 100.105,250.729 96.48,256.984   102.735,253.359 97.354,258.188 104.423,256.673 97.814,259.602 105.005,260.346 97.814,261.09 104.423,264.02 97.354,262.505   102.735,267.334 96.48,263.709 100.105,269.964 95.276,264.583 96.791,271.653 93.861,265.043 93.117,272.234 92.373,265.043   89.444,271.653 90.958,264.583 86.129,269.964 89.755,263.709 83.499,267.334 88.88,262.505 81.811,264.02 88.42,261.09   81.229,260.346 88.42,259.602 81.811,256.673 88.88,258.188 83.499,253.359 89.755,256.984 86.129,250.729 90.958,256.109   89.444,249.04 92.373,255.65 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#41479B"
    },
    points: "130.061,308.156 103.983,308.156 80.078,288.598 80.078,260.346 156.139,260.346   156.139,288.598 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M143.1,251.654h-0.003c-0.007-0.594-0.489-1.074-1.084-1.074s-1.077,0.48-1.084,1.074h-0.003  c0,3.772-2.185,8.988-4.866,12.724c-3.742-4.725-5.15-10.205-5.68-13.655c-0.253-1.646-2.032-2.559-3.522-1.814  c-0.717,0.359-1.2,1.059-1.324,1.851c-1.664,10.658-6.688,15.187-9.941,17.049c-4.871-4.709-6.476-12.33-7.005-16.835  c-0.206-1.751-2.08-2.757-3.657-1.968c-0.607,0.304-1.058,0.852-1.27,1.497c-6.816,20.778-25.757,22.883-25.757,22.883v6.52h76.061  v-2.173v-2.173v-2.173v-2.173v-2.173C145.273,266.866,143.1,251.654,143.1,251.654z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0AA00"
    },
    d: "M153.966,232.095c-8.693-4.346-8.693-8.693-8.693-8.693s-10.866-4.346-19.559-4.346   c0,0,2.173-4.346-2.173-4.346s-6.52,0-6.52,0s-2.173,0-6.52,0s-2.173,4.346-2.173,4.346c-8.693,0-19.559,4.346-19.559,4.346   s0,4.346-8.693,8.693s-8.693,14.126-8.693,14.126c0,1.8,1.459,3.26,3.26,3.26s3.26-1.459,3.26-3.26c0-0.371-0.075-0.722-0.19-1.055   l0.19-0.032l21.732-15.212h17.385h17.385l21.732,15.212l0.19,0.032c-0.114,0.333-0.19,0.684-0.19,1.055c0,1.8,1.459,3.26,3.26,3.26   s3.26-1.459,3.26-3.26C162.659,246.221,162.659,236.441,153.966,232.095z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0AA00"
    },
    d: "M160.486,258.173c-2.173,0-8.693,0-8.693-6.52s8.693-6.52,8.693-6.52l-13.039-4.346   C143.1,256,151.793,256,151.793,275.559c0,17.521-19.559,28.251-26.078,28.251c-6.52,0-8.693,4.346-8.693,4.346   s-2.173-4.346-8.693-4.346c-6.52,0-26.078-10.731-26.078-28.251c0-19.559,8.693-19.559,4.346-34.771l-13.039,4.346   c0,0,8.693,0,8.693,6.52c0,6.52-6.52,6.52-8.693,6.52c-2.173,0-10.866,0-10.866,10.866s10.866,23.905,26.078,32.598   s8.693,17.385,28.251,17.385s13.039-8.693,28.251-17.385c15.212-8.693,26.078-21.732,26.078-32.598   S162.659,258.173,160.486,258.173z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M112.676,224.159l-5.257-2.362c-0.872-0.392-1.84-0.484-2.772-0.269   c-3.389,0.783-11.795,3.358-18.049,10.567l6.52,2.173L112.676,224.159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M121.368,224.159l5.257-2.362c0.872-0.392,1.84-0.484,2.772-0.269   c3.389,0.783,11.795,3.358,18.049,10.567l-6.52,2.173L121.368,224.159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M117.79,225.576l3.962-3.962c0.212-0.212,0.212-0.556,0-0.768s-0.556-0.212-0.768,0l-3.962,3.962   l-3.962-3.962c-0.212-0.212-0.556-0.212-0.768,0s-0.212,0.556,0,0.768l3.962,3.962l-3.962,3.962c-0.212,0.212-0.212,0.556,0,0.768   c0.106,0.106,0.245,0.159,0.384,0.159s0.278-0.053,0.384-0.159l3.962-3.962l3.962,3.962c0.106,0.106,0.245,0.159,0.384,0.159   s0.278-0.053,0.384-0.159c0.212-0.212,0.212-0.556,0-0.768L117.79,225.576z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M160.486,245.134c0-3.698-3.494-5.296-6.52-5.989v-1.721c-4.091-0.383-6.374-1.921-10.341-4.623  c-1.528-1.042-3.261-2.222-5.352-3.493c-7.641-4.642-13.515-5.312-16.905-5.15v3.59h-8.693v-3.59  c-3.39-0.162-9.264,0.508-16.905,5.15c-2.091,1.271-3.824,2.451-5.352,3.493c-3.967,2.702-6.249,4.24-10.341,4.623v1.721  c-3.026,0.693-6.52,2.291-6.52,5.989l6.52-2.173v0.991c6.167-0.454,9.694-2.822,14.011-5.762c1.463-0.997,3.121-2.126,5.067-3.309  c4.963-3.017,8.82-3.95,11.347-4.17v3.557h13.039v-3.557c2.526,0.22,6.384,1.153,11.347,4.17c1.946,1.182,3.604,2.311,5.067,3.309  c4.317,2.94,7.844,5.308,14.011,5.762v-0.991L160.486,245.134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3CC8FF"
    },
    d: "M143.1,210.879v-2.689h-6.054c1.058-0.908,1.707-1.978,1.707-3.26c0-6.004-13.66-7.606-21.732-7.606  s-21.732,1.602-21.732,7.606c0,1.282,0.65,2.352,1.707,3.26h-6.054v2.689c-5.32,1.187-9.67,4.043-9.898,4.195l2.411,3.616  c0.059-0.04,6.039-3.981,11.834-3.981v-2.173h43.463v2.173c5.795,0,11.774,3.941,11.834,3.981l2.411-3.616  C152.77,214.922,148.421,212.066,143.1,210.879z M125.715,207.589v-1.651c0-1.064-1-1.844-2.032-1.586l-6.661,1.665l-6.661-1.665  c-1.032-0.258-2.032,0.523-2.032,1.586v1.651c-4.882-0.717-7.769-1.911-8.556-2.658c1.176-1.116,6.934-3.26,17.249-3.26  s16.073,2.143,17.249,3.26C133.484,205.677,130.597,206.872,125.715,207.589z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M117.293,235.089l0.551,1.651l1.74,0.013c0.225,0.002,0.319,0.289,0.137,0.423l-1.4,1.034   l0.525,1.659c0.068,0.215-0.177,0.393-0.36,0.262l-1.416-1.012l-1.416,1.012c-0.183,0.131-0.428-0.047-0.36-0.262l0.525-1.659   l-1.4-1.034c-0.181-0.134-0.088-0.421,0.137-0.423l1.74-0.013l0.551-1.651C116.92,234.875,117.222,234.875,117.293,235.089z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M108.774,235.645l0.721,1.584l1.732-0.169c0.224-0.022,0.347,0.254,0.181,0.406l-1.284,1.175   l0.696,1.595c0.09,0.207-0.134,0.409-0.331,0.298l-1.514-0.858l-1.302,1.155c-0.169,0.15-0.43-0.002-0.385-0.222l0.348-1.705   l-1.501-0.881c-0.194-0.114-0.132-0.41,0.092-0.435l1.729-0.196l0.374-1.7C108.38,235.472,108.681,235.44,108.774,235.645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M100.026,237.976l1.047,1.39l1.655-0.54c0.214-0.07,0.394,0.173,0.265,0.358l-0.999,1.425   l1.025,1.407c0.133,0.182-0.043,0.428-0.258,0.362l-1.664-0.509l-1.021,1.41c-0.132,0.183-0.421,0.092-0.424-0.134l-0.03-1.74   l-1.656-0.535c-0.214-0.069-0.217-0.372-0.004-0.445l1.646-0.566l-0.003-1.741C99.604,237.892,99.89,237.796,100.026,237.976z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M91.258,241.672l1.222,1.24l1.568-0.755c0.203-0.098,0.414,0.119,0.31,0.319l-0.801,1.545   l1.202,1.258c0.156,0.163,0.014,0.43-0.208,0.393l-1.717-0.285l-0.825,1.532c-0.107,0.198-0.405,0.147-0.438-0.076l-0.26-1.721   l-1.712-0.311c-0.222-0.04-0.265-0.34-0.063-0.44l1.557-0.779l-0.233-1.725C90.829,241.645,91.1,241.511,91.258,241.672z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M125.368,235.645l-0.721,1.584l-1.732-0.169c-0.224-0.022-0.347,0.254-0.181,0.406l1.284,1.175   l-0.696,1.595c-0.09,0.207,0.134,0.409,0.331,0.298l1.514-0.858l1.302,1.155c0.169,0.15,0.43-0.002,0.385-0.222l-0.348-1.705   l1.501-0.881c0.194-0.114,0.132-0.41-0.092-0.435l-1.729-0.196l-0.374-1.7C125.762,235.472,125.461,235.44,125.368,235.645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M134.116,237.976l-1.047,1.39l-1.655-0.54c-0.214-0.07-0.394,0.173-0.265,0.358l0.999,1.425   l-1.025,1.407c-0.133,0.182,0.043,0.428,0.258,0.362l1.664-0.509l1.021,1.41c0.132,0.183,0.421,0.092,0.424-0.134l0.03-1.74   l1.656-0.535c0.214-0.069,0.217-0.372,0.004-0.445l-1.646-0.566l0.003-1.741C134.538,237.892,134.251,237.796,134.116,237.976z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M142.884,241.672l-1.222,1.24l-1.568-0.755c-0.203-0.098-0.414,0.119-0.31,0.319l0.801,1.545   l-1.202,1.258c-0.156,0.163-0.014,0.43,0.208,0.393l1.717-0.285l0.825,1.532c0.107,0.198,0.405,0.147,0.438-0.076l0.26-1.721   l1.712-0.311c0.222-0.04,0.265-0.34,0.063-0.44l-1.557-0.779l0.233-1.725C143.313,241.645,143.042,241.511,142.884,241.672z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8C5A28"
    },
    points: "102.014,287.239 113.083,294.642 126.462,294.642 132.642,289.345 127.888,291.246   112.132,291.246 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M109.552,277.686l-1.068,10.775l-4.863-1.856C103.621,286.606,105.858,281.413,109.552,277.686z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 119.15,
    y: 273.42,
    style: {
      fill: "#8C5A28"
    },
    width: 0.719,
    height: 18.349
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.8,
    y: 274.97,
    style: {
      fill: "#8C5A28"
    },
    width: 0.719,
    height: 16.796
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.52,
    y: 274.97,
    style: {
      fill: "#8C5A28"
    },
    width: 0.719,
    height: 16.796
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M122.041,290.024h-5.062c-0.271,0-0.491-0.22-0.491-0.491v-2.889c0-0.271,0.22-0.491,0.491-0.491   h5.062c0.271,0,0.491,0.22,0.491,0.491v2.889C122.531,289.804,122.312,290.024,122.041,290.024z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M122.041,284.862h-5.062c-0.271,0-0.491-0.22-0.491-0.491v-2.889c0-0.271,0.22-0.491,0.491-0.491   h5.062c0.271,0,0.491,0.22,0.491,0.491v2.889C122.531,284.643,122.312,284.862,122.041,284.862z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M122.041,280.109h-5.062c-0.271,0-0.491-0.22-0.491-0.491v-2.889c0-0.271,0.22-0.491,0.491-0.491   h5.062c0.271,0,0.491,0.22,0.491,0.491v2.889C122.531,279.889,122.312,280.109,122.041,280.109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M128.282,290.024h-4.247c-0.271,0-0.491-0.22-0.491-0.491v-2.889c0-0.271,0.22-0.491,0.491-0.491   h4.247c0.271,0,0.491,0.22,0.491,0.491v2.889C128.773,289.804,128.553,290.024,128.282,290.024z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M128.282,285.272h-4.247c-0.271,0-0.491-0.22-0.491-0.491v-2.283c0-0.271,0.22-0.491,0.491-0.491   h4.247c0.271,0,0.491,0.22,0.491,0.491v2.283C128.773,285.052,128.553,285.272,128.282,285.272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M128.282,280.561h-4.247c-0.271,0-0.491-0.22-0.491-0.491v-1.758c0-0.271,0.22-0.491,0.491-0.491   h4.247c0.271,0,0.491,0.22,0.491,0.491v1.758C128.773,280.342,128.553,280.561,128.282,280.561z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M115.004,290.024h-4.247c-0.271,0-0.491-0.22-0.491-0.491v-2.889c0-0.271,0.22-0.491,0.491-0.491   h4.247c0.271,0,0.491,0.22,0.491,0.491v2.889C115.495,289.804,115.275,290.024,115.004,290.024z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M115.004,285.272h-4.247c-0.271,0-0.491-0.22-0.491-0.491v-2.283c0-0.271,0.22-0.491,0.491-0.491   h4.247c0.271,0,0.491,0.22,0.491,0.491v2.283C115.495,285.052,115.275,285.272,115.004,285.272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M115.004,280.561h-4.247c-0.271,0-0.491-0.22-0.491-0.491v-1.758c0-0.271,0.22-0.491,0.491-0.491   h4.247c0.271,0,0.491,0.22,0.491,0.491v1.758C115.495,280.342,115.275,280.561,115.004,280.561z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "113.239,274.972 113.239,277.142 116.434,276.037  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "126.508,274.972 126.508,277.142 129.703,276.037  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "119.861,273.412 119.861,275.583 123.056,274.478  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8C5A28"
    },
    points: "111.373,258.748 115.219,261.32 119.867,261.32 122.014,259.479 120.363,260.14   114.889,260.14 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M113.992,255.429l-0.371,3.744l-1.689-0.645C111.932,258.528,112.709,256.724,113.992,255.429z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 117.33,
    y: 253.95,
    style: {
      fill: "#8C5A28"
    },
    width: 0.25,
    height: 6.375
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.64,
    y: 254.49,
    style: {
      fill: "#8C5A28"
    },
    width: 0.25,
    height: 5.835
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.02,
    y: 254.49,
    style: {
      fill: "#8C5A28"
    },
    width: 0.25,
    height: 5.835
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M118.331,259.715h-1.759c-0.094,0-0.171-0.076-0.171-0.171v-1.004c0-0.094,0.076-0.171,0.171-0.171   h1.759c0.094,0,0.171,0.076,0.171,0.171v1.004C118.502,259.639,118.425,259.715,118.331,259.715z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M118.331,257.922h-1.759c-0.094,0-0.171-0.076-0.171-0.171v-1.004c0-0.094,0.076-0.171,0.171-0.171   h1.759c0.094,0,0.171,0.076,0.171,0.171v1.004C118.502,257.846,118.425,257.922,118.331,257.922z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M118.331,256.271h-1.759c-0.094,0-0.171-0.076-0.171-0.171v-1.004c0-0.094,0.076-0.171,0.171-0.171   h1.759c0.094,0,0.171,0.076,0.171,0.171v1.004C118.502,256.194,118.425,256.271,118.331,256.271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M120.5,259.715h-1.476c-0.094,0-0.171-0.076-0.171-0.171v-1.004c0-0.094,0.076-0.171,0.171-0.171   h1.476c0.094,0,0.171,0.076,0.171,0.171v1.004C120.67,259.639,120.594,259.715,120.5,259.715z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M120.5,258.065h-1.476c-0.094,0-0.171-0.076-0.171-0.171v-0.793c0-0.094,0.076-0.171,0.171-0.171   h1.476c0.094,0,0.171,0.076,0.171,0.171v0.793C120.67,257.988,120.594,258.065,120.5,258.065z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M120.5,256.428h-1.476c-0.094,0-0.171-0.076-0.171-0.171v-0.611c0-0.094,0.076-0.171,0.171-0.171   h1.476c0.094,0,0.171,0.076,0.171,0.171v0.611C120.67,256.352,120.594,256.428,120.5,256.428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M115.886,259.715h-1.476c-0.094,0-0.171-0.076-0.171-0.171v-1.004c0-0.094,0.076-0.171,0.171-0.171   h1.476c0.094,0,0.171,0.076,0.171,0.171v1.004C116.057,259.639,115.981,259.715,115.886,259.715z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M115.886,258.065h-1.476c-0.094,0-0.171-0.076-0.171-0.171v-0.793c0-0.094,0.076-0.171,0.171-0.171   h1.476c0.094,0,0.171,0.076,0.171,0.171v0.793C116.057,257.988,115.981,258.065,115.886,258.065z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M115.886,256.428h-1.476c-0.094,0-0.171-0.076-0.171-0.171v-0.611c0-0.094,0.076-0.171,0.171-0.171   h1.476c0.094,0,0.171,0.076,0.171,0.171v0.611C116.057,256.352,115.981,256.428,115.886,256.428z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "115.273,254.486 115.273,255.24 116.383,254.856  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "119.883,254.486 119.883,255.24 120.993,254.856  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "117.574,253.944 117.574,254.698 118.684,254.314  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M109.404,247.307h-4.323c-0.604,0-1.098-0.494-1.098-1.098v-1.503c0-0.604,0.494-1.098,1.098-1.098   h4.323c0.604,0,1.098,0.494,1.098,1.098v1.503C110.503,246.813,110.008,247.307,109.404,247.307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M130.855,247.307h-3.363c-0.606,0-1.098-0.492-1.098-1.098v-1.503c0-0.606,0.492-1.098,1.098-1.098   h3.363c0.606,0,1.098,0.492,1.098,1.098v1.503C131.953,246.816,131.461,247.307,130.855,247.307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M143.746,250.092h-2.497c-0.347,0-0.628-0.281-0.628-0.628v-1.034c0-0.347,0.281-0.628,0.628-0.628   h2.497c0.347,0,0.628,0.281,0.628,0.628v1.034C144.374,249.81,144.093,250.092,143.746,250.092z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCr);
export default __webpack_public_path__ + "static/media/CR.6e99fe4e6e88926d83e6a603087f965b.svg";
export { ForwardRef as ReactComponent };